import React, { useContext, useState } from "react"
import { MobergCheckbox, MobergColumn, MobergHeader, MobergRow, MobergText } from "../../../../../Moberg"
import { ConfigureWindowModalContext } from "../ConfigureWindowModal"
import { useEMRDataProvider } from "../../../../../Providers/EMRDataProvider"
import { RenderStrategy } from "../../../../../Pages/Data/Visualize/DataReview/Types/Trace"
import { EMRDataFilter } from "../../../../../Pages/Data/Visualize/DataReview/Types/Graph"

export const MedicationGraphModalities: React.FC = () => {
    const { currentGraph, updateGraphProperty } = useContext(ConfigureWindowModalContext)
    const { harmonizedMedications } = useEMRDataProvider()
    const [filters, setFilters] = useState<Array<EMRDataFilter>>(currentGraph?.renderStrategy === RenderStrategy.MEDICATION ? (currentGraph.filters ?? []) : [])

    const updateFilters = (filters: EMRDataFilter[], shouldInclude: boolean) => {
        setFilters(previous => {
            const incomingIds = new Set(filters.map(f => f.id))

            const result = shouldInclude
                ? [...previous, ...filters.filter(f => !previous.some(p => p.id === f.id))]
                : previous.filter(p => !incomingIds.has(p.id))

            updateGraphProperty("filters", result)
            return result
        })
    }

    const isMedicationClassChecked = (medicationClass: string) => harmonizedMedications
        .filter(harmonizedMedication => harmonizedMedication.class === medicationClass)
        .every(harmonizedMedication => !!filters.find(f => f.id === harmonizedMedication.id.toString()))

    const onMedicationClassSelected = (medicationClass: string, isChecked: boolean) => {
        const medicationIds = harmonizedMedications
            .filter(harmonizedMedication => harmonizedMedication.class === medicationClass)
            .map(harmonizedMedication => ({id: harmonizedMedication.id.toString(), name: harmonizedMedication.name}))

        updateFilters(medicationIds, isChecked)
    }

    const medicationClasses = [...new Set(harmonizedMedications.map(harmonizedMedication => harmonizedMedication.class))]

    return (
        <MobergColumn gap="8px">
            <MobergHeader>Medications</MobergHeader>

            <MobergRow verticalAlign="start" gap="16px">
                {medicationClasses.map((medicationClass: string) => (
                    <MobergColumn key={medicationClass} style={{ padding: "8px",whiteSpace: "nowrap" }}>
                        <MobergRow gap="8px" expand={false}>
                            <MobergCheckbox isChecked={isMedicationClassChecked(medicationClass)} onChange={isChecked => onMedicationClassSelected(medicationClass, isChecked)} />
                            <MobergHeader>
                                {medicationClass} 
                            </MobergHeader>
                        </MobergRow>
                        
                        {harmonizedMedications
                            .filter(harmonizedMedication => harmonizedMedication.class === medicationClass)
                            .map(harmonizedMedication => (
                                <MobergRow key={harmonizedMedication.id} gap="8px">
                                    <MobergCheckbox isChecked={!!filters.find(f => f.id === harmonizedMedication.id.toString())} onChange={isChecked => updateFilters([{ id: harmonizedMedication.id.toString(), name: harmonizedMedication.name }], isChecked)} />
                                    <MobergText>{harmonizedMedication.name}</MobergText>
                                </MobergRow>
                            ))
                        }
                    </MobergColumn>
                ))}

            </MobergRow>
        </MobergColumn>
    )
}